import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/text-v2.0.0'
import v210 from '@nodes/text-v2.1.0'

export default reactNode(
	'Text',
	{
		'v2.0.0': v200,
		'v2.1.0': v210,
	},
	{ allowChildren: true, docs: '' }
)
